/** Narrows a selected-odds push patch to the cart lifecycle contract. */

const own = (value, key) => Object.prototype.hasOwnProperty.call(value ?? {}, key);

const normalizedState = patch => String(
  patch?.state ?? patch?.displayState ?? '',
).trim().toUpperCase();

export const sportsnewSelectedPatchIsUnavailable = patch => (
  patch?.unavailable === true || normalizedState(patch) === 'UNAVAILABLE'
);

export function sportsnewSelectedCartPatch(patch = {}) {
  const next = {};
  for (const field of [
    'bettable',
    'locked',
    'is_suspended',
    'suspended',
    'state',
    'displayState',
    'reason',
    'lockReason',
  ]) {
    if (own(patch, field)) next[field] = patch[field];
  }
  if (!own(next, 'bettable') && own(patch, 'isBettable')) {
    next.bettable = patch.isBettable;
  }
  if (!own(next, 'is_suspended') && own(patch, 'suspended')) {
    next.is_suspended = patch.suspended;
  }
  if (own(patch, 'unavailable') || own(patch, 'state') || own(patch, 'displayState')) {
    next.unavailable = sportsnewSelectedPatchIsUnavailable(patch);
  }
  return next;
}

export default Object.freeze({
  sportsnewSelectedCartPatch,
  sportsnewSelectedPatchIsUnavailable,
});
